"use client";
// Imports
import { useState, useEffect } from "react";
import Link from "next/link";
import { UIElement } from "@/components";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { Fragment } from "react";
import { Button } from "@/components/ui/button";
import useStore from "@/lib/state";
import { DrawerClose } from "@/components/ui/drawer";
import { useKindeSession } from "@/components/KindeWrapper";
// MobileNav
export function MobileNav({ data, showDates }) {
  const { user } = useKindeSession();
  // Variables
  const { showModeNav, outOfShowModeNav, showModeEnabled } = data;
  const nav = showModeEnabled ? showModeNav : outOfShowModeNav;
  const doChildrenExist = (item) => item?.children?.length > 0;

  const { isMobileMenuOpen, toggleMobileMenu, setMobileMenuOpen } = useStore();

  const [subMenu, setSubMenu] = useState({ open: false, index: null });

  function openSubMenu(index) {
    setSubMenu({ open: true, index });
  }

  function closeAllMenus() {
    setMobileMenuOpen(false);
    setSubMenu({ open: false, index: null });
  }

  // Render
  return (
    <div
      id="mobile-meny-content"
      className="flex flex-col justify-between pt-4 overflow-x-hidden min-h-[70dvh]"
    >
      <div
        className={`relative ${
          subMenu.open ? "-translate-x-[100%]" : "translate-x-[0%]"
        } w-[100%] transition-all ease-in-out duration-150`}
      >
        {nav &&
          nav.map((item, index) => (
            <div key={index}>
              {!doChildrenExist(item) ? (
                <div
                  key={index}
                  className="w-full space-y-2 border-b-2 border-black/10 level-2"
                >
                  {!item.page.action || item.page.action.length < 1 ? (
                    <DrawerClose asChild>
                      <Link
                        href={item?.page?.url ?? "#"}
                        target={item?.page?.entry_id ? "_self" : "_blank"}
                        // onClick={closeAllMenus}
                        className="flex items-center justify-between w-full py-4"
                      >
                        <span className="font-heading font-heading-sentence">
                          {item?.page?.title}
                        </span>
                      </Link>
                    </DrawerClose>
                  ) : (
                    <UIElement
                      isMobile
                      showDates={showDates}
                      slug={item?.page?.action[0]?.slug}
                      user={user}
                    />
                  )}
                </div>
              ) : (
                <div
                  key={index}
                  className="flex justify-between w-full transition-all duration-150 ease-in-out-expo level-2"
                >
                  <button
                    className="group flex items-center justify-between w-full py-4 border-b-2 border-black/10"
                    onClick={() => openSubMenu(index)}
                  >
                    <span className="font-heading font-heading-sentence">
                      {item?.page?.title}
                    </span>
                    <ArrowRight />
                  </button>
                  <div
                    className={`absolute h-full top-0 left-[100%] bottom-0 w-full transition-all ease-in-out duration-150 ${
                      subMenu.open && subMenu.index === index
                        ? "opacity-100 z-50 pointer-events-auto"
                        : "opacity-0 z-0 pointer-events-none"
                    }`}
                  >
                    <button
                      onClick={() => setSubMenu({ open: false, index: null })}
                      className="group flex items-center w-full space-x-4 border-b-2 border-black/10"
                    >
                      <ArrowLeft />
                      <h2 className="flex items-center w-full py-4 level-2 font-heading font-heading-sentence">
                        {item?.page?.heading || item?.page?.title}
                      </h2>
                    </button>
                    {item?.children.map((child, index) => (
                      <Fragment key={index}>
                        {!child?.page?.action ||
                        child?.page?.action?.length < 1 ? (
                          <DrawerClose asChild>
                            <Link
                              href={child?.page?.url ?? "#"}
                              target={
                                child?.page?.entry_id ? "_self" : "_blank"
                              }
                              // onClick={closeAllMenus}
                              className="flex items-center justify-between w-full py-4 border-b-2 border-black/10"
                            >
                              <span className="font-heading font-heading-sentence">
                                {child?.page?.title}
                              </span>
                              {/* <ArrowRight /> */}
                            </Link>
                          </DrawerClose>
                        ) : (
                          <UIElement
                            isMobile
                            showDates={showDates}
                            slug={child?.page?.action[0]?.slug}
                            user={user}
                          />
                        )}
                      </Fragment>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
      </div>
      {/* <div className="pt-4">
        <Button asChild className="w-full py-4">
          <Link target="_blank" href="https://premier.ticketek.com.au/">
            Buy Tickets
          </Link>
        </Button>
      </div> */}
    </div>
  );
}
